import React, { useEffect, useState, useRef } from 'react';
import { X } from 'lucide-react';
interface MultiSelectProps {
  label?: string;
  options: {
    value: string;
    label: string;
  }[];
  value: string[];
  onChange: (value: string[]) => void;
  error?: string;
  placeholder?: string;
}
export function MultiSelect({
  label,
  options,
  value,
  onChange,
  error,
  placeholder = 'Select...'
}: MultiSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  const toggleOption = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter(v => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };
  const removeOption = (optionValue: string) => {
    onChange(value.filter(v => v !== optionValue));
  };
  const selectedLabels = options.filter(opt => value.includes(opt.value));
  return <div className="w-full" ref={containerRef} data-id="element-280">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-281">
          {label}
        </label>}
      <div className="relative" data-id="element-282">
        <div className={`w-full min-h-[42px] px-3 py-2 border rounded-lg text-sm focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent cursor-pointer bg-white ${error ? 'border-red-500' : 'border-gray-300'}`} onClick={() => setIsOpen(!isOpen)} data-id="element-283">
          {selectedLabels.length === 0 ? <span className="text-gray-400" data-id="element-284">{placeholder}</span> : <div className="flex flex-wrap gap-1" data-id="element-285">
              {selectedLabels.map(option => <span key={option.value} className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs" data-id="element-286">
                  {option.label}
                  <button onClick={e => {
              e.stopPropagation();
              removeOption(option.value);
            }} className="hover:text-blue-900" data-id="element-287">
                    <X className="w-3 h-3" data-id="element-288" />
                  </button>
                </span>)}
            </div>}
        </div>
        {isOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto" data-id="element-289">
            {options.map(option => <div key={option.value} className="px-3 py-2 hover:bg-gray-50 cursor-pointer flex items-center gap-2" onClick={() => toggleOption(option.value)} data-id="element-290">
                <input type="checkbox" checked={value.includes(option.value)} onChange={() => {}} className="w-4 h-4 text-blue-600 border-gray-300 rounded" data-id="element-291" />
                <span className="text-sm text-gray-900" data-id="element-292">{option.label}</span>
              </div>)}
          </div>}
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-293">{error}</p>}
    </div>;
}